export const getFileExtension = (filename) => {
	if (!filename) return false;
	var a = filename.split(".");
	if (a.length === 1 || (a[0] === "" && a.length === 2)) {
		return "";
	}
	return a.pop().toLowerCase(); // feel free to tack .toLowerCase() here if you want
};
